import { AlertTriangleIcon, CheckIcon, CircleCheckBigIcon, FlagIcon, InfoIcon } from 'lucide-react';
import type { CalloutVariant } from '../../../data/referenceGuides/types';

/**
 * The source packets use emoji for these (⚠ 🚩 ✓ ℹ ✅). Emoji in headings
 * renders inconsistently across platforms and is on the AI-slop blacklist,
 * so each maps to a lucide icon instead.
 *
 * All four accent colours clear WCAG AA on the card surface:
 * amber 10.98:1 · rose 6.81:1 · emerald 9.53:1 · violet.link 6.73:1.
 */
const VARIANTS: Record<CalloutVariant, {
  icon: typeof InfoIcon;
  border: string;
  bg: string;
  text: string;
}> = {
  warning: {
    icon: AlertTriangleIcon,
    border: 'border-callout-warning/25',
    bg: 'bg-callout-warning/[0.06]',
    text: 'text-callout-warning'
  },
  flag: {
    icon: FlagIcon,
    border: 'border-callout-flag/25',
    bg: 'bg-callout-flag/[0.06]',
    text: 'text-callout-flag'
  },
  tip: {
    icon: CheckIcon,
    border: 'border-callout-tip/25',
    bg: 'bg-callout-tip/[0.06]',
    text: 'text-callout-tip'
  },
  info: {
    icon: InfoIcon,
    border: 'border-callout-info/25',
    bg: 'bg-callout-info/[0.06]',
    text: 'text-callout-info'
  },
  bottomLine: {
    icon: CircleCheckBigIcon,
    border: 'border-callout-tip/30',
    bg: 'bg-callout-tip/[0.08]',
    text: 'text-callout-tip'
  }
};
export function CalloutBlock({
  variant,
  title,
  body
}: {
  variant: CalloutVariant;
  title: string;
  body: string;
}) {
  const v = VARIANTS[variant];
  const Icon = v.icon;
  return <div className={`rounded-2xl border ${v.border} ${v.bg} p-6 sm:p-7 flex gap-4`} data-id="element-245" data-mp="3go7jrd4v576f">
      <Icon aria-hidden="true" className={`w-5 h-5 flex-shrink-0 mt-1 ${v.text}`} data-id="element-246" data-mp="32wat7diuf5c5" />
      <div data-id="element-247" data-mp="37um47rkvjlvy">
        <p className={`${v.text} text-xs font-bold uppercase tracking-widest mb-2`} data-id="element-248" data-mp="37ucb3v4j8ym1">{title}</p>
        <p className="text-white/70 text-base leading-relaxed" data-id="element-249" data-mp="2sx38g59s48f0">{body}</p>
      </div>
    </div>;
}